const SearchQuery=(type, endCursorQuery, yearMonthQuery, qQuery, afterQuery, dateQuery, searchQuery)=> {
        console.log("ST", type);
        const optional_query = type === 'posts' ? "eventACF { eventDate }" : "";
        return  `query Query(${endCursorQuery} ${yearMonthQuery} ${qQuery} $first: Int) {
        ${type}(first: $first, ${afterQuery} where: {${dateQuery} ${searchQuery} orderby: { field: DATE, order: DESC } }) { 
        nodes {
              databaseId
              date
              title
              ${optional_query}
              featuredImage {
                node {
                  m: sourceUrl(size: MSIZE)
                }
              }
          }
          pageInfo {
            endCursor
            hasNextPage
          } } }`;
}

export {SearchQuery};
